import React from "react"
import Fade from "react-reveal/Fade"
import data from "../yourdata"

const About = () => {
  return (
    <div className="secion" id="about">
      <div className="container">
        <div className="about-section">
          <div className="content">
            <Fade bottom cascade>
              <h1>Mi Perfil</h1>
            </Fade>
            <p>
              {data.aboutParaOne}
              <br></br>
              <br></br>
              {data.aboutParaTwo}
              <br></br>
              <br></br>
              <div dangerouslySetInnerHTML={{"__html" : data.aboutParaThree}}></div>
            </p>
          </div>
          <div className="image-wrapper">
            <img src={data.aboutImage} style={{backgroundSize : "cover"}} alt="about"></img>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
